import { render, staticRenderFns } from "./ClientEditAddressDialog.vue?vue&type=template&id=52303b5c"
import script from "./ClientEditAddressDialog.vue?vue&type=script&lang=js"
export * from "./ClientEditAddressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports